export default __webpack_public_path__ + "static/media/desk-image.516db055.svg";